/**
 * Generated by orval v8.22.0 🍺
 * Do not edit manually.
 * PHRMPC.Manning.Web.API | v1
 * OpenAPI spec version: 1.0.0
 */
import type {
  AcknowledgeIncidentRecordFile,
  CancelIncidentRecord,
  CompleteIncidentRecord,
  ConfirmIncidentRecordFile,
  CreateIncidentRecord,
  IncidentRecordDto,
  IncidentRecordFileContentDto,
  IncidentRecordFileInfoDto,
  PagedResultOfIncidentRecordFileInfoDto,
  PagedResultOfIncidentRecordSummaryDto,
  SearchIncidentRecordsParams,
  StartOngoingIncidentRecord,
  SubmitIncidentRecord,
  UpdateIncidentRecord,
  UploadFilesIncidentRecordsBody
} from '../models';

import { customInstance } from '../axios';



type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];


  /**
 * @summary Returns a paged list of incidentrecords matching the supplied filter and sort criteria.
 */
export const searchIncidentRecords = (
    params?: SearchIncidentRecordsParams,
 options?: SecondParameter<typeof customInstance<PagedResultOfIncidentRecordSummaryDto>>,) => {
      return customInstance<PagedResultOfIncidentRecordSummaryDto>(
      {url: `/incident-management/incident-records`, method: 'GET',
        params
    },
      options);
    }
  /**
 * @summary Creates a new IncidentRecord from the supplied command.
 */
export const createIncidentRecord = (
    createIncidentRecord: CreateIncidentRecord,
 options?: SecondParameter<typeof customInstance<IncidentRecordDto>>,) => {
      return customInstance<IncidentRecordDto>(
      {url: `/incident-management/incident-records`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: createIncidentRecord
    },
      options);
    }
  /**
 * @summary Returns the IncidentRecord identified by the route id.
 */
export const getIncidentRecordById = (
    id: string,
 options?: SecondParameter<typeof customInstance<IncidentRecordDto>>,) => {
      return customInstance<IncidentRecordDto>(
      {url: `/incident-management/incident-records/${id}`, method: 'GET'
    },
      options);
    }
  /**
 * @summary Replaces the data of the IncidentRecord identified by the route id.
 */
export const updateIncidentRecord = (
    id: string,
    updateIncidentRecord: UpdateIncidentRecord,
 options?: SecondParameter<typeof customInstance<IncidentRecordDto>>,) => {
      return customInstance<IncidentRecordDto>(
      {url: `/incident-management/incident-records/${id}`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: updateIncidentRecord
    },
      options);
    }
  /**
 * @summary Submits an IncidentRecord (Draft -> Created).
 */
export const submitIncidentRecords = (
    id: string,
    submitIncidentRecord: SubmitIncidentRecord,
 options?: SecondParameter<typeof customInstance<void>>,) => {
      return customInstance<void>(
      {url: `/incident-management/incident-records/${id}/submit`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: submitIncidentRecord
    },
      options);
    }
  /**
 * @summary Transitions an IncidentRecord to On-going status (Created -> On-going).
 */
export const startOngoingIncidentRecords = (
    id: string,
    startOngoingIncidentRecord: StartOngoingIncidentRecord,
 options?: SecondParameter<typeof customInstance<void>>,) => {
      return customInstance<void>(
      {url: `/incident-management/incident-records/${id}/ongoing`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: startOngoingIncidentRecord
    },
      options);
    }
  /**
 * @summary Completes an IncidentRecord process (On-going -> Completed).
 */
export const completeIncidentRecords = (
    id: string,
    completeIncidentRecord: CompleteIncidentRecord,
 options?: SecondParameter<typeof customInstance<void>>,) => {
      return customInstance<void>(
      {url: `/incident-management/incident-records/${id}/complete`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: completeIncidentRecord
    },
      options);
    }
  /**
 * @summary Cancels an IncidentRecord (Draft/Created -> Cancelled).
 */
export const cancelIncidentRecords = (
    id: string,
    cancelIncidentRecord: CancelIncidentRecord,
 options?: SecondParameter<typeof customInstance<void>>,) => {
      return customInstance<void>(
      {url: `/incident-management/incident-records/${id}/cancel`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: cancelIncidentRecord
    },
      options);
    }
  export const uploadFilesIncidentRecords = (
    incidentRecordId: string,
    uploadFilesIncidentRecordsBody: UploadFilesIncidentRecordsBody,
 options?: SecondParameter<typeof customInstance<void>>,) => {const formData = new FormData();
if(uploadFilesIncidentRecordsBody.files !== undefined) {
 uploadFilesIncidentRecordsBody.files.forEach(value => formData.append(`files`, value));
 }

if(uploadFilesIncidentRecordsBody.fileFieldTypeId !== undefined) {
 formData.append(`fileFieldTypeId`, uploadFilesIncidentRecordsBody.fileFieldTypeId.toString())
 }

if(uploadFilesIncidentRecordsBody.isSignedDocument !== undefined) {
 formData.append(`isSignedDocument`, uploadFilesIncidentRecordsBody.isSignedDocument.toString())
 }

if(uploadFilesIncidentRecordsBody.sourceUnsignedId !== undefined) {
 formData.append(`sourceUnsignedId`, uploadFilesIncidentRecordsBody.sourceUnsignedId);
 }

      return customInstance<void>(
      {url: `/incident-management/incident-records/${incidentRecordId}/files`, method: 'POST',
      headers: {'Content-Type': 'multipart/form-data', },
       data: formData
    },
      options);
    }
  /**
 * @summary Lists every file uploaded against the IncidentRecord identified by the route incidentRecordId.
 */
export const getIncidentRecordFiles = (
    incidentRecordId: string,
 options?: SecondParameter<typeof customInstance<PagedResultOfIncidentRecordFileInfoDto>>,) => {
      return customInstance<PagedResultOfIncidentRecordFileInfoDto>(
      {url: `/incident-management/incident-records/${incidentRecordId}/files`, method: 'GET'
    },
      options);
    }
  /**
 * @summary Confirms/submits the file identified by the route id, uploaded against the IncidentRecord identified by incidentRecordId. Only the file's own uploader may confirm it, and a file may only be confirmed once (Task 157758).
 */
export const confirmIncidentRecordFile = (
    incidentRecordId: string,
    id: string,
    confirmIncidentRecordFile: ConfirmIncidentRecordFile,
 options?: SecondParameter<typeof customInstance<IncidentRecordFileInfoDto>>,) => {
      return customInstance<IncidentRecordFileInfoDto>(
      {url: `/incident-management/incident-records/${incidentRecordId}/files/${id}/confirm`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: confirmIncidentRecordFile
    },
      options);
    }
  /**
 * @summary Records member-acknowledgement of the unsigned copy of the file identified by the route id, uploaded against the IncidentRecord identified by incidentRecordId (Task 157758).
 */
export const acknowledgeIncidentRecordFile = (
    incidentRecordId: string,
    id: string,
    acknowledgeIncidentRecordFile: AcknowledgeIncidentRecordFile,
 options?: SecondParameter<typeof customInstance<IncidentRecordFileInfoDto>>,) => {
      return customInstance<IncidentRecordFileInfoDto>(
      {url: `/incident-management/incident-records/${incidentRecordId}/files/${id}/acknowledge`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: acknowledgeIncidentRecordFile
    },
      options);
    }
  /**
 * @summary Returns the metadata of the file identified by the route fileId, uploaded against the IncidentRecord identified by incidentRecordId.
 */
export const getIncidentRecordFile = (
    incidentRecordId: string,
    id: string,
 options?: SecondParameter<typeof customInstance<IncidentRecordFileInfoDto>>,) => {
      return customInstance<IncidentRecordFileInfoDto>(
      {url: `/incident-management/incident-records/${incidentRecordId}/files/${id}`, method: 'GET'
    },
      options);
    }
  /**
 * @summary Deletes the file associated with the transmittal document identified by the route documentId and fileId.
 */
export const deleteIncidentRecordFile = (
    incidentRecordId: string,
    id: string,
 options?: SecondParameter<typeof customInstance<void>>,) => {
      return customInstance<void>(
      {url: `/incident-management/incident-records/${incidentRecordId}/files/${id}`, method: 'DELETE'
    },
      options);
    }
  /**
 * @summary Downloads the content of the file identified by the route fileId, uploaded against the IncidentRecord identified by incidentRecordId.
 */
export const downloadIncidentRecordFile = (
    incidentRecordId: string,
    id: string,
 options?: SecondParameter<typeof customInstance<IncidentRecordFileContentDto>>,) => {
      return customInstance<IncidentRecordFileContentDto>(
      {url: `/incident-management/incident-records/${incidentRecordId}/files/${id}/content`, method: 'GET'
    },
      options);
    }
  export type SearchIncidentRecordsResult = NonNullable<Awaited<ReturnType<typeof searchIncidentRecords>>>
export type CreateIncidentRecordResult = NonNullable<Awaited<ReturnType<typeof createIncidentRecord>>>
export type GetIncidentRecordByIdResult = NonNullable<Awaited<ReturnType<typeof getIncidentRecordById>>>
export type UpdateIncidentRecordResult = NonNullable<Awaited<ReturnType<typeof updateIncidentRecord>>>
export type SubmitIncidentRecordsResult = NonNullable<Awaited<ReturnType<typeof submitIncidentRecords>>>
export type StartOngoingIncidentRecordsResult = NonNullable<Awaited<ReturnType<typeof startOngoingIncidentRecords>>>
export type CompleteIncidentRecordsResult = NonNullable<Awaited<ReturnType<typeof completeIncidentRecords>>>
export type CancelIncidentRecordsResult = NonNullable<Awaited<ReturnType<typeof cancelIncidentRecords>>>
export type UploadFilesIncidentRecordsResult = NonNullable<Awaited<ReturnType<typeof uploadFilesIncidentRecords>>>
export type GetIncidentRecordFilesResult = NonNullable<Awaited<ReturnType<typeof getIncidentRecordFiles>>>
export type ConfirmIncidentRecordFileResult = NonNullable<Awaited<ReturnType<typeof confirmIncidentRecordFile>>>
export type AcknowledgeIncidentRecordFileResult = NonNullable<Awaited<ReturnType<typeof acknowledgeIncidentRecordFile>>>
export type GetIncidentRecordFileResult = NonNullable<Awaited<ReturnType<typeof getIncidentRecordFile>>>
export type DeleteIncidentRecordFileResult = NonNullable<Awaited<ReturnType<typeof deleteIncidentRecordFile>>>
export type DownloadIncidentRecordFileResult = NonNullable<Awaited<ReturnType<typeof downloadIncidentRecordFile>>>
